export const PURCHASE = 'purchase';
export const PLAYER_START = 'player_start';
export const PLAYER_PLAY = 'player_play';
export const PLAYER_PAUSE = 'player_pause';
export const PLAYER_CLOSE = 'player_close';
export const USER_PROPERTIES_UPDATE = 'user_properties';
export const PLAYER_ERROR = 'player_error';
